var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { reads } from '@ember/object/computed';
import { computed, set } from '@ember/object';
import { isPresent, isNone } from '@ember/utils';
import { attr, hasMany } from '@ember-data/model';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import TrackRelationships from 'ember-data-relationship-tracker';
let ProductSet = (_dec = attr('string', {
  defaultValue: CatalogObjectType.PRODUCT_SET,
  protoEnum: CatalogObjectTypeProto
}), _dec2 = hasMany('connect/category'), _dec3 = hasMany('connect/item'), _dec4 = hasMany('connect/item-variation'), _dec5 = hasMany('connect/category'), _dec6 = hasMany('connect/item'), _dec7 = hasMany('connect/item-variation'), _dec8 = computed('requiredCategories.[]', 'allowedCategories.[]', function () {
  if (isPresent(this.requiredCategories)) {
    return this.requiredCategories;
  } else {
    return this.allowedCategories;
  }
}), _dec9 = computed('requiredItems.[]', 'allowedItems.[]', function () {
  if (isPresent(this.requiredItems)) {
    return this.requiredItems;
  } else {
    return this.allowedItems;
  }
}), _dec10 = computed('requiredItemVariations.[]', 'allowedItemVariations.[]', function () {
  if (isPresent(this.requiredItemVariations)) {
    return this.requiredItemVariations;
  } else {
    return this.allowedItemVariations;
  }
}), _dec11 = attr('boolean', {
  allowNull: true
}), _dec12 = reads('hasDirtyFields'), _dec13 = computed('categories.[]', 'itemVariations.[]', 'items.[]', 'surcharges.[]', 'matchAllProducts', function () {
  return this.matchAllProducts || isPresent(this.categories) || isPresent(this.items) || isPresent(this.itemVariations) || isPresent(this.surcharges);
}), (_class = (_class2 = class ProductSet extends CatalogObject.extend(TrackRelationships) {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "requiredCategories", _descriptor2, this);
    _initializerDefineProperty(this, "requiredItems", _descriptor3, this);
    _initializerDefineProperty(this, "requiredItemVariations", _descriptor4, this);
    _initializerDefineProperty(this, "allowedCategories", _descriptor5, this);
    _initializerDefineProperty(this, "allowedItems", _descriptor6, this);
    _initializerDefineProperty(this, "allowedItemVariations", _descriptor7, this);
    // Convenience methods for accessing associated products
    _initializerDefineProperty(this, "categories", _descriptor8, this);
    _initializerDefineProperty(this, "items", _descriptor9, this);
    _initializerDefineProperty(this, "itemVariations", _descriptor10, this);
    _initializerDefineProperty(this, "matchAllProducts", _descriptor11, this);
    _initializerDefineProperty(this, "isDirty", _descriptor12, this);
    _initializerDefineProperty(this, "productsAreSelected", _descriptor13, this);
  }
  clear() {
    this.categories.clear();
    this.items.clear();
    this.itemVariations.clear();
  }
  revert() {
    this.rollbackAttributes();
  }

  /**
   * This method allows a user to pass in a list of catalog object ids selected in the Product Selector
   * and have this method automatically update allowedItems/allowedCategories/allowedItemVariations to match
   * the passed in list of ids.
   * @param {Array} tokensHash - Array of object identifiers used to updated allowedCategories/Items/ItemVariations
   */
  updateAllowedModelsFromTokensHash(tokensHash) {
    function hydrateTokens(store, klass, tokens) {
      if (isPresent(tokens)) {
        return tokens.map(token => store.peekRecord(klass, token)).filter(Boolean);
      } else {
        return [];
      }
    }
    const allowedCategories = hydrateTokens(this.store, 'connect/category', tokensHash.categories);

    // If a whole item is selected, don't select the variations as well.
    let allowedItems = hydrateTokens(this.store, 'connect/item', tokensHash.items);
    const hydratedVariations = hydrateTokens(this.store, 'connect/item-variation', tokensHash.itemVariations);
    const allowedItemVariations = hydratedVariations.map(variation => {
      if (allowedItems.includes(variation.get('item'))) {
        return null;
      } else {
        return variation;
      }
    }).compact();

    /**
     * If new categories are added, make sure items in those categories
     * are not present in the `allItems` array.
     */
    const newCategories = allowedCategories.filter(category => {
      return isNone(this.allowedCategories.findBy('id', category.id));
    });
    if (isPresent(newCategories)) {
      allowedItems = allowedItems.filter(item => {
        return isNone(newCategories.find(category => {
          return isPresent(category.items.findBy('id', item.id));
        }));
      });
    }
    this.watchRelationship('allowedCategories', () => {
      this.allowedCategories.setObjects(allowedCategories);
    });
    this.watchRelationship('allowedItems', () => {
      this.allowedItems.setObjects(allowedItems);
    });
    this.watchRelationship('allowedItemVariations', () => {
      this.allowedItemVariations.setObjects(allowedItemVariations);
    });
  }
  deleteModel() {
    set('deleted', true);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/product-set'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "requiredCategories", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "requiredItems", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "requiredItemVariations", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "allowedCategories", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "allowedItems", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "allowedItemVariations", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "categories", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "items", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "itemVariations", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "matchAllProducts", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "productsAreSelected", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { ProductSet as default };